import React, { useState } from "react";
import WebHeader from "../WebHeader";
import WebFooter from "../WebFooter";
import dashboardIcon from "../../assets/img/dashboard.svg";
import { NavLink } from "react-router-dom";

import logo from "../../assets/img/logo.png";
import buyIcon from "../../assets/img/buy.svg";
import myTransaction from "../../assets/img/my-transaction.svg";
import directAffiliate from "../../assets/img/direct-affiliate.svg";
import allAffiliate from "../../assets/img/all-affiliate.svg";

import walletStatement from "../../assets/img/wallet-statement.svg";
import purchasehistory from "../../assets/img/purchase-history.svg";

import directReward from "../../assets/img/direct-reward.svg";
import weeklybonus from "../../assets/img/weekly-bonus.svg";
import weeklybonuseligible from "../../assets/img/weekly-bonus-eligible.svg";
import levelbonus from "../../assets/img/level-bonus.svg";
import roibonus from "../../assets/img/roi-bonus.svg";
import totalroibonus from "../../assets/img/total-roi-bonus.svg";


import withdrawalIcon from "../../assets/img/request-withdrawal.svg";
import createTicket from "../../assets/img/create-ticket.svg";
import ticketList from "../../assets/img/ticket-list.svg";
import withdrawalhistory from "../../assets/img/withdrawal-history.svg";
import logoutIcon from "../../assets/img/logout.svg";
import BGImge from "../../assets/img/bg.jpg";
import videobg from "../../assets/img/video.mp4";
import "../../assets/css/style.css?v=1";

const MainLayout = ({ children }) => {
  const wallet = localStorage.getItem("wallet");
  const email = localStorage.getItem("email");
  const Loginid = localStorage.getItem("Loginid");
    const Username = localStorage.getItem("Username");
  const fullAddress = Username;//wallet || email;
 // const shortAddress = fullAddress
 //   ? fullAddress.slice(0, 5) + "…" + fullAddress.slice(-3)
   // : "";

     const shortAddress = Username;

  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    navigator.clipboard
      .writeText(fullAddress)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 5000);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const [isOpen, setIsOpen] = useState(false);
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {/* <video className="video-bg" preload="auto" autoPlay loop muted playsInline>
        <source src={videobg} type="video/mp4" />
      </video> */}




      <img src={BGImge} alt="" className="BGImge" />

      <span className="bg-overlay"></span>

      <div className="dashapp">
        <div className="topbar-mobile" style={{ display: "none" }}>
          <a href="/" data-discover="true" className="logoText">
            <img alt="logo.png" className="logo-mobile" src={logo} />
          </a>

          <button className="burger-btn" onClick={toggleSidebar}>
            {isOpen ? (
              <i className="fa-solid fa-xmark"></i>
            ) : (
              <i className="fa-solid fa-bars"></i>
            )}
          </button>
        </div>

        {/* Overlay background */}
        {isOpen && <div className="overlay" onClick={toggleSidebar}></div>}

        <div
          className={`sidebar ${isOpen ? "open" : ""} sidemenuSection scroller`}
        >
          <div className="Sidemenumain" translate="no">
            {/* Logo */}
            <div className="sm_logo text-center">
              <a href="/" data-discover="true">
                <img alt="logo.png" className="logo-web" src={logo} />
              </a>
            </div>

            {/* Wallet Address */}
            <div className="walletAddress">
              <span>
                <img
                  alt="walletIcon"
                  className="img-fluid"
                  width="20"
                  height="20"
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADxSURBVHgB1VTtDYJADC2E/7CBbqBuwAhuIG7gBuoE6AQygk7iCLCBOAG+Jj1zudyn/tGXvBwtvdf2jkL068hMxzRNFZYquDHLhqAgxPZYduBIfnDCI0RPzgiuDHxIhV4gpgEvtne5kfVrFIbNoj2yx7SsznuL1keX4ACuKL7aFlyDnUuQJFuoQpIKn6avoERApMZSi7kAS/iuqu08UYw/q1Zz3US8tAXPwZ78gndwafj4EmfKTm15ADcQ4Gf/OUdWyDGdVNXLINiHIUbQsofFG92nXwq3UMWMng/vM+Rrh9iZ4iZFx0E3Pv59CUZ97P4DL3aRlYgHUyQlAAAAAElFTkSuQmCC"
                />
              </span>
              <span className="address-copy">{shortAddress}</span>
              <button className="btn btnEmpty" onClick={handleCopy}>
                <img
                  alt="sm-copyIconpng"
                  className="img-fluid"
                  width="20"
                  height="20"
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADaSURBVHgBzVPbDcIwDHRQB+gIWYENygYdoUzECNAN2ADYgA2aDegG4dw6Ugl5VFE/epLlSuecr9KZaCMo92GtrdHazPyIeiuljE9UIqLRHqhahmNg3qCOQRZCLeojrqLghahriKsWm0ZYHhePGjQdePMC17EzzD99IX8zb52GKQ52d4PYefmwQw3OiZ2hEyLuN604p0Nok9g2KSHhjcwHhYqwb6E6l6M1QneaE32hQkw54iDCzUnEcve2DqU5+ks2xx5kj88B3SS0NKp3Z6ISGxsK35rDz61thi9XM3/iYDpv7QAAAABJRU5ErkJggg=="
                />
              </button>

              {copied && (
                <span className="copied-message">
                  Copied <i className="fas fa-check-circle text-success"></i>
                </span>
              )}
            </div>

            {/* Menu List */}
            <div
              className="smList scroller"
              onClick={() => setIsOpen(false)} // ✅ Close sidebar automatically on click
            >
              <ul>
                <li>
                  <NavLink
                    to="/dashboard"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img
                      alt="mIcon"
                      width="24"
                      height="24"
                      src={dashboardIcon}
                    />
                    <span>Dashboard</span>
                  </NavLink>
                </li>
              </ul>

              <div className="smSubLabel">
                <span>Package</span>
              </div>
              <ul>
    {/*           <li>
                  <NavLink
                    to="/buy-packages/myprofile"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img alt="mIcon" width="24" height="24" src={buyIcon} />
                    <span>My Profile</span>
                  </NavLink>
                </li> */}

                {/* <li>
                  <NavLink
                    to="/buy-packages/purchase"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img alt="mIcon" width="24" height="24" src={buyIcon} />
                    <span>Purchase Package</span>
                  </NavLink>
                </li> */}

                <li>
                  <NavLink
                    to="/ico-participation/buy-ico"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img alt="mIcon" width="24" height="24" src={buyIcon} />
                    <span>Buy Package</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/ico-participation/history"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img
                      alt="mIcon"
                      width="24"
                      height="24"
                      src={purchasehistory}
                    />
                    <span>Purchase History</span>
                  </NavLink>
                </li>
              </ul>

              <div className="smSubLabel">
                <span>My Affiliate</span>
              </div>
              <ul>
                <li>
                  <NavLink
                    to="/my-affiliate/direct"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img
                      alt="mIcon"
                      width="24"
                      height="24"
                      src={directAffiliate}
                    />
                    <span>Direct Affiliate</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/my-affiliate/all"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img
                      alt="mIcon"
                      width="24"
                      height="24"
                      src={allAffiliate}
                    />
                    <span>All Affiliate</span>
                  </NavLink>
                </li>
              </ul>

              <div className="smSubLabel">
                <span>My Earnings</span>
              </div>
              <ul>
                <li>
                  <NavLink
                    to="/my-earnings/direct-bonus"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img
                      alt="mIcon"
                      width="24"
                      height="24"
                      src={directReward}
                    />
                    <span>Direct Reward</span>
                  </NavLink>
                </li>

                <li>
                  <NavLink
                    to="/my-earnings/total-roi-bonus"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img
                      alt="mIcon"
                      width="24"
                      height="24"
                      src={totalroibonus}
                    />
                    <span>Total ROI Bonus</span>
                  </NavLink>
                </li> 
                 <li>
                  <NavLink
                    to="/my-earnings/roi-bonus"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img
                      alt="mIcon"
                      width="24"
                      height="24"
                      src={roibonus}
                    />
                    <span>ROI Bonus</span>
                  </NavLink>
                </li> 
                 <li>
                  <NavLink
                    to="/my-earnings/level-bonus"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img
                      alt="mIcon"
                      width="24"
                      height="24"
                      src={levelbonus}
                    />
                    <span>ROI Level Bonus</span>
                  </NavLink>
                </li> 

              <li>
                  <NavLink
                    to="/my-earnings/weekly-bonus-elegible"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img
                      alt="mIcon"
                      width="24"
                      height="24"
                      src={weeklybonuseligible}
                    />
                    <span>Weekly Bonus Eligible</span>
                  </NavLink>
                </li>

                
              <li>
                  <NavLink
                    to="/my-earnings/weekly-bonus"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img
                      alt="mIcon"
                      width="24"
                      height="24"
                      src={weeklybonus}
                    />
                    <span>Weekly Bonus</span>
                  </NavLink>
                </li>


               {/*  <li>
                  <NavLink
                    to="/my-earnings/statement"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img
                      alt="mIcon"
                      width="24"
                      height="24"
                      src={walletStatement}
                    />
                    <span>Earning Statement</span>
                  </NavLink>
                </li> */}
              </ul>

            {/*   <div className="smSubLabel">
                <span>Token Wallet</span>
              </div>
              <ul>
                <li>
                  <NavLink
                    to="/token-wallet/statement"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img
                      alt="mIcon"
                      width="24"
                      height="24"
                      src={walletStatement}
                    />
                    <span>Wallet Statement</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/token-wallet/request-withdrawal"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img
                      alt="mIcon"
                      width="24"
                      height="24"
                      src={withdrawalIcon}
                    />
                    <span>Request Withdrawal</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/token-wallet/withdrawal-history"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img
                      alt="mIcon"
                      width="24"
                      height="24"
                      src={myTransaction}
                    />
                    <span>Withdrawal History</span>
                  </NavLink>
                </li>
              </ul> */}

             <div className="smSubLabel">
                <span>USDT Wallet</span>
              </div>
              <ul>
                <li>
                  <NavLink
                    to="/usdt-wallet/statement"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img
                      alt="mIcon"
                      width="24"
                      height="24"
                      src={walletStatement}
                    />
                    <span>Wallet Statement</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/usdt-wallet/request-withdrawal"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img
                      alt="mIcon"
                      width="24"
                      height="24"
                      src={withdrawalIcon}
                    />
                    <span>Request Withdrawal</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/usdt-wallet/withdrawal-history"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img
                      alt="mIcon"
                      width="24"
                      height="24"
                      src={withdrawalhistory}
                    />
                    <span>Withdrawal History</span>
                  </NavLink>
                </li>
              </ul>

              <div className="smSubLabel">
                <span>Help</span>
              </div>
              <ul>
                <li>
                  <NavLink
                    to="/help/create-ticket"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img
                      alt="mIcon"
                      width="24"
                      height="24"
                      src={createTicket}
                    />
                    <span>Create Ticket</span>
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/help/tickets"
                    className={({ isActive }) =>
                      isActive ? "active-menu" : ""
                    }
                  >
                    <img alt="mIcon" width="24" height="24" src={ticketList} />
                    <span>Ticket List</span>
                  </NavLink>
                </li>
              </ul>

              <div className="smSubLabel">
                <span>Logout</span>
              </div>
              <ul>
                <li>
                  <NavLink to="/logout" className="btn btnEmpty w-100">
                    <img
                      alt="mIcon"
                      width="24"
                      height="24"
                      src={logoutIcon}
                    />
                    <span>Logout</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="appDashMainContent">
          <div className="dashcont dashappMainContent">
            <main className="main-content">{children}</main>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainLayout;
